export const JOB_FORM_MODES = {
  CREATE: 'create',
  EDIT: 'edit'
} as const;

export type JobFormMode = (typeof JOB_FORM_MODES)[keyof typeof JOB_FORM_MODES];

export const JOB_FORM_STEPS = {
  JOB_INFO: 'JOB_INFO',
  RESOURCES: 'RESOURCES'
} as const;

export type JobFormStepType = keyof typeof JOB_FORM_STEPS;

export const JOB_MODAL_TITLES = {
  NEW_JOB: 'New Job',
  EDIT_JOB: 'Edit Job'
} as const;

export const JOB_MODAL_SUBTITLES = {
  UPDATE_JOB_DETAILS: 'UPDATE JOB DETAILS',
  COMPLETE_DETAILS: 'COMPLETE THE DETAILS TO CREATE A NEW JOB',
  ADD_RESOURCES: 'ADD RESOURCES TO JOB'
} as const;
